import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class FormalEducationMetricsServices {
  getFormalEducationMetrics = params =>
    AxiosClient.get("/api/app/capacitacion_metrica_educacion_formal/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getFormalEducationMetricById = id =>
    AxiosClient.get(`/api/app/capacitacion_metrica_educacion_formal/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFormalEducationMetrics = data =>
    AxiosClient.post("/api/app/capacitacion_metrica_educacion_formal/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFormalEducationMetrics = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_metrica_educacion_formal/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFormalEducationMetrics = id =>
    AxiosClient.delete(`/api/app/capacitacion_metrica_educacion_formal/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FormalEducationMetricsServices();